import {NEWBUYER_FAILED, API_CALL, RECEIVE_NEWBUYER, REQUEST_NEWBUYER} from "./types";
import {hasError} from "./actionHelpers";
import {getOrder} from "./orderActions";
import {toast} from "react-toastify";

export const changeBuyer = (id, buyer) => ({
  type: API_CALL,
  onRequest: REQUEST_NEWBUYER,
  onResponse: RECEIVE_NEWBUYER,
  onError: NEWBUYER_FAILED,
  responseKey: 'newbuyer',
  payload: {
    method: 'POST',
    url: `/ios/${id}/changeBuyer?buyer=${buyer}`
  }
});

export const changeBuyerWithNotifications = (id, buyer, history) => (dispatch, getState) => {
  let message = `new buyer for ${id}`;
  toast.info(message, { theme: 'colored', toastId: message });
  return dispatch(changeBuyer(id, buyer)).then(() => {
    const err = hasError(getState(), 'newbuyerRequest', dispatch);
    if (err) {
      toast.error(err, { theme: 'colored', toastId: err });
      return;
    }
    const newProposalId = getState().newbuyerRequest.newbuyer.id;
    message = `New buyer using ${newProposalId}`;
    toast.success(message, { theme: 'colored', toastId: message });
    history.push(`/ios/${newProposalId}`);
    dispatch(getOrder(newProposalId));
  });
};
